import { cn } from '../../utils';

export type Crumb = {
    id: string;
    name: string;
    current: boolean;
    href: string;
};

export type CrumbLinkAsProps = {
    crumb: Crumb;
    className: string;
};

type BreadcrumbsProps = {
    crumbs: Crumb[];
    className?: string | object;
    LinkAs?: ({ crumb, className }: CrumbLinkAsProps) => JSX.Element;
};

export default function Breadcrumbs({
    className,
    crumbs,
    LinkAs = DefaultLinkAs,
}: BreadcrumbsProps) {
    return (
        <nav
            className={cn('alli-flex', className)}
            aria-label="Breadcrumb"
            data-testid="Breadcrumbs">
            <ol
                role="list"
                className="alli-mb-1 alli-flex alli-items-center alli-space-x-4">
                {crumbs.map((crumb, index) => (
                    <li key={crumb.id}>
                        <div className="alli-flex alli-items-center">
                            {index > 0 && (
                                <span className="alli-h-5 alli-text-gray-700">
                                    /
                                </span>
                            )}
                            <LinkAs
                                crumb={crumb}
                                className={cn('alli-text-sm alli-font-medium', {
                                    'alli-text-blue-gray-700 hover:alli-text-black':
                                        index < crumbs.length - 1,
                                    'alli-ml-4': index > 0,
                                    'alli-text-gray-600':
                                        index === crumbs.length - 1,
                                })}
                            />
                        </div>
                    </li>
                ))}
            </ol>
        </nav>
    );
}

function DefaultLinkAs({ crumb, className }: CrumbLinkAsProps) {
    return (
        <a
            href={crumb.href}
            className={cn(className)}
            aria-current={crumb.current ? 'page' : undefined}>
            {crumb.name}
        </a>
    );
}
